import { SCRIPT_TRACKING_HEADERS } from '@marketplace-web/domain/script-detection-data/server'

export const EMAIL_REGISTER_HEADERS = {
  [SCRIPT_TRACKING_HEADERS['X-Browser-Compat']]: '1',
}

export const FACEBOOK_REGISTER_HEADERS = {
  [SCRIPT_TRACKING_HEADERS['X-Browser-Compat']]: '2',
}

export const GOOGLE_REGISTER_HEADERS = {
  [SCRIPT_TRACKING_HEADERS['X-Browser-Compat']]: '3',
}

export const APPLE_REGISTER_HEADERS = {
  [SCRIPT_TRACKING_HEADERS['X-Browser-Compat']]: '4',
}
